type StepIndicatorProps = {
  steps: Array<{ number: number; label: string }>
  currentStep: number
}

export const StepIndicator = ({ steps, currentStep }: StepIndicatorProps) => (
  <ol className="flex items-center gap-2 overflow-x-auto py-1">
    {steps.map((step, index) => {
      const isCompleted = step.number < currentStep
      const isActive = step.number === currentStep
      const isLast = index === steps.length - 1

      return (
        <li key={step.label} className="flex min-w-fit items-center gap-2">
          <div className="flex items-center gap-2">
            <span
              className={[
                'inline-flex h-6 w-6 items-center justify-center rounded-full border text-[11px] font-semibold',
                isCompleted
                  ? 'border-(--color-action-primary) bg-[color-mix(in_srgb,var(--color-action-primary)_16%,transparent)] text-(--color-action-primary)'
                  : isActive
                    ? 'border-(--color-text-primary) bg-(--color-bg-card) text-(--color-text-primary)'
                    : 'border-(--color-border-default) bg-(--color-bg-card) text-(--color-text-muted)',
              ].join(' ')}
            >
              {step.number}
            </span>
            <span
              className={[
                'text-xs whitespace-nowrap',
                isActive
                  ? 'font-semibold text-(--color-text-primary)'
                  : isCompleted
                    ? 'font-medium text-(--color-text-secondary)'
                    : 'font-medium text-(--color-text-muted)',
              ].join(' ')}
            >
              {step.label}
            </span>
          </div>
          {!isLast ? (
            <span
              aria-hidden
              className="h-px w-6 bg-[color-mix(in_srgb,var(--color-border-default)_86%,transparent)]"
            />
          ) : null}
        </li>
      )
    })}
  </ol>
)
